/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import moment from 'moment';
import React, {
    useEffect, useCallback, useState, useContext,
} from 'react';
import Modal from 'react-modal';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { DapService } from '../../service/dap.service';
import HeaderContext from '../../Components/Context/HeaderContext';
import ThreeDotsLoader from '../../Components/LoadingDots';
import ViewOffersSkeleton from '../../Components/Skeletons/ViewOffersSkeleton';
import { CamelCase } from '../../redux/helper/CamelCase';
import ViewDapSkeleton from '../../Components/Skeletons/ViewDapSkeleton';
import CommonLog from '../../redux/helper/CommonLog';
import LogActivity from '../../Components/LogActivity';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};
function ViewDap() {
    const { id } = useParams();
    const [DealDetails, setDealDetails] = useState([]);
    const [OpenPopup, setOpenPopup] = useState('');
    const [actvloader, setactvloader] = useState(false);
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const getDetails = useCallback(
        async () => {
            const OfferDetals = await DapService.GetDapDetails(id);
            if (!OfferDetals.error && OfferDetals.data.success_status) {
                setTimeout(() => {
                    setDealDetails(OfferDetals.data.data);
                }, 500);
            }
        },
        [id],
    );

    useEffect(() => {
        getDetails();
    }, [getDetails]);
    const handleActivateOrDeactivate = (status) => {
        setactvloader(true);
        DapService.offerActiveOrDeactivateAccount(status, DealDetails.offer_code).then((res) => {
            if (!res.error && res.data.success_status) {
                setOpenPopup('');
                setactvloader(false);
                SetSuccessMessage(res.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                    setcolorValue(false);
                }, 3000);
                getDetails();
            } else {
                setactvloader(false);
                SetErrorMessage(res.message);
                setcolorValue(true);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(false);
                }, 3000);
            }
        });
    };
    const generateAddress = (arr) => {
        let val = '';
        arr.forEach((data) => {
            val += val === '' ? data : `,${data}`;
        });
        return val;
    };

    function ActiveFirst() {
        return (
            <>
                {DealDetails.activated_datetime !== null
    && (

        <CommonLog
            date={moment.unix(DealDetails.activated_datetime).format('YYYY/MM/DD').split('/').reverse()
                .join('/')}
            time={moment.unix(DealDetails?.activated_datetime).format('hh:mm a')}
            name={DealDetails.activated_user_name}
            action="activated"
        />
    )}

                {DealDetails.deactivated_datetime !== null
    && (
        <CommonLog
            date={moment.unix(DealDetails.deactivated_datetime).format('YYYY/MM/DD').split('/').reverse()
                .join('/')}
            time={moment.unix(DealDetails?.deactivated_datetime).format('hh:mm a')}
            name={DealDetails.deactivated_user_name}
            action="deactivated"
        />
    )}
            </>
        );
    }
    function DeactiveFirst() {
        return (
            <>
                <>
                    {DealDetails.deactivated_datetime !== null
    && (
        <CommonLog
            date={moment.unix(DealDetails.deactivated_datetime).format('YYYY/MM/DD').split('/').reverse()
                .join('/')}
            time={moment.unix(DealDetails?.deactivated_datetime).format('hh:mm a')}
            name={DealDetails.deactivated_user_name}
            action="deactivated"
        />
    )}
                </>
                {DealDetails.activated_datetime !== null
    && (
        <CommonLog
            date={moment.unix(DealDetails.activated_datetime).format('YYYY/MM/DD').split('/').reverse()
                .join('/')}
            time={moment.unix(DealDetails?.activated_datetime).format('hh:mm a')}
            name={DealDetails.activated_user_name}
            action="activated"
        />
    )}
            </>
        );
    }
    return (
        <div>

            <Modal
                style={customStyles}
                isOpen={OpenPopup !== ''}
                ariaHideApp={false}
                onClick={() => {
                    setOpenPopup('');
                    setactvloader(false);
                }}
            >
                <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]">
                    <div
                        className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                    >
                        <div className="modal-header flex flex-shrink-0 items-center justify-between p-4 pt-7 rounded-t-md">
                            <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel">
                                {DealDetails.offer_status === '0' ? 'Active' : 'Deactive'}
                                {' '}
                                {' '}
                                Offer
                            </h5>

                            <button
                                type="button"
                                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body relative px-9 pt-2 pb-6 text-center">
                            <p className="text-xs6 font-normal text-[#555259]">
                                {`${DealDetails.offer_code}`}
                                {' '}
                                is currently
                                {' '}
                                {DealDetails.offer_status === '1' ? 'Active' : 'Deactive'}
                                . Are you sure you
                                {' '}
                                want to
                                {' '}
                                {DealDetails.offer_status === '1' ? 'Deactivate' : 'Activate'}
                                ?
                            </p>
                        </div>

                        <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-6 rounded-b-md">
                            <button
                                onClick={() => {
                                    setOpenPopup('');
                                    setactvloader(false);
                                }}
                                type="button"
                                className="border border-[#555259] bg-[#ffffff] text-base font-normal text-[#555259] py-3 px-14 rounded-lg"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-14 rounded-lg"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => handleActivateOrDeactivate(DealDetails.offer_status === '0' ? 'activate' : 'deactivate')}
                            >
                                {actvloader ? <ThreeDotsLoader /> : 'Yes'}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>

            {Object.keys(DealDetails).length === 0 ? <ViewDapSkeleton />
                : (
                    <div className="py-6 pl-12 pr-[77px] main-screen">
                        <div className="flex justify-between items-center">
                            <div className="flex items-center">
                                <Link to="/manage-freight-policy">
                                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                                </Link>
                                <h5 className="text-xs4 font-normal text-[#555259]">View Freight Policy (DAP)</h5>
                            </div>
                            <div>
                                <>
                                    {DealDetails.policy_status === 'Draft' && (
                                        <Link to={`/manage-freight-policy/${id}/update`}>
                                            <button
                                                type="button"
                                                className="w-[102px] border border-[#555259] rounded-lg h-[38px] text-xs6 font-bold text-[#555259]"
                                            >
                                                Edit Policy
                                            </button>
                                        </Link>
                                    )}

                                </>
                                {DealDetails.offer_status === '1' && (
                                    <button
                                        onClick={() => setOpenPopup('active')}
                                        type="button"
                                        className="w-[147px] border border-[#555259] rounded-lg h-[38px] text-xs6 font-bold text-[#555259] ml-1"
                                        data-bs-toggle="modal"
                                        data-bs-target="#deactivateOfferModal1"
                                    >
                                        {DealDetails.offer_status === '1' ? 'Deactivate ' : 'Activate '}
                                        Offer
                                    </button>
                                )}
                            </div>
                        </div>
                        {Object.keys(DealDetails).length > 0 ? (
                            <motion.div
                                className="px-4 pt-[34px]"
                                animate={{ opacity: 1, x: 0 }}
                                initial={{ opacity: 0, x: -10 }}
                                exit={{ opacity: 0, x: -10 }}
                                transition={{ duration: 0.15 }}
                            >
                                <div className="w-[90%]">
                                    <p className="text-xs2 font-semibold text-[#808285]">Policy Name</p>
                                    <p className="text-lg font-normal text-[#090406] pt-1">{DealDetails.policy_name}</p>
                                </div>
                                <div className="flex -mx-2 mt-8">
                                    <div className="px-2 w-[18%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Start Date</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.start_date.replace(/-/g, '/').split('/').reverse().join('/')}</p>
                                    </div>
                                    <div className="px-2 w-[18%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">End Date</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.end_date.replace(/-/g, '/').split('/').reverse().join('/')}</p>
                                    </div>
                                    <div className="px-2 w-[18%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Destination Type</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{CamelCase(DealDetails.destination_type)}</p>
                                    </div>
                                    <div className="px-2 w-[18%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Status</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.policy_status}</p>
                                    </div>
                                </div>
                                <div className="flex -mx-2 mt-4">
                                    <div className="px-2 w-[18%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Freight Charges</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">
                                            {' '}
                                            {DealDetails.dap_charges}
                                            %
                                        </p>
                                    </div>
                                    <div className="px-2 w-[18%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Ship From</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5">{DealDetails.ship_from.DESCRIPTION || DealDetails.ship_from.CITY }</p>
                                    </div>
                                    <div className="px-2 w-[25.28%]">
                                        <p className="text-xs2 font-semibold text-[#808285]">Ship To (Pin codes)</p>
                                        <p className="text-lg font-normal text-[#090406] pt-1.5 break-words w-[350px]">{generateAddress(DealDetails.ship_to)}</p>
                                    </div>
                                </div>
                                <div className="mt-8 w-full">
                                    <div className="mt-2 rounded-[22px] bg-[#F5F5FA] px-2.5 py-2.5 w-full">
                                        <div>
                                            {DealDetails.product_categories.map((criteria, idx) => (

                                                <div className="bg-[#ffffff] rounded-[16px] px-[22px] pt-4 pb-4">
                                                    <div className="px-3.5">
                                                        <div className="flex -mx-2 w-[90%]">
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Main Category</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5">{criteria.MAIN_CATEGORY}</p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Product Group</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5">{criteria?.SEGMENT2}</p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Product Sub Group</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5">{criteria?.SEGMENT3}</p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Product Sub Sub Group</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5">{criteria?.SEGMENT4 }</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex -mx-2 pb-2.5 flex-wrap">
                                                            <>
                                                                {criteria.products.map((item, i) => (
                                                                    <div className="px-2 mt-[22px]">
                                                                        <p className="text-xs2 font-semibold text-[#808285]">
                                                                            Product(SKU)
                                                                            {' '}
                                                                            {i + 1}
                                                                        </p>
                                                                        <p className="text-lg font-normal text-[#090406] pt-0.5">
                                                                            {item?.DESCRIPTION?.length > 27 ? `${item?.DESCRIPTION?.substring(0, 28)}...` : item?.DESCRIPTION}
                                                                            {' '}
                                                                            <span className="text-xs13">
                                                                                (
                                                                                {
                                                                                    item?.INVENTORY_ITEM_ID
                                                                                }
                                                                                )

                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                ))}

                                                            </>

                                                        </div>
                                                    </div>
                                                    <div className="rounded-lg bg-[#F5F5FA] px-3.5 py-8 w-[90%]">
                                                        <div className="flex -mx-2">
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Minimum List Price</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5">
                                                                    ₹
                                                                    {DealDetails.min_list_price}
                                                                </p>
                                                            </div>
                                                            <div className="px-2 w-1/4">
                                                                <p className="text-xs2 font-semibold text-[#808285]">Maximum List Price</p>
                                                                <p className="text-lg font-normal text-[#090406] pt-0.5">
                                                                    ₹
                                                                    {DealDetails.max_list_price}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="pt-7 pb-2.5" />
                                    </div>
                                </div>
                                <div className="mt-[22px] w-[392px]">
                                    <h5 className="text-sm font-bold text-[#090406]">Activity Log</h5>
                                    <div className="mt-2 rounded-[22px] bg-[#F5F5FA] p-[15px] w-full">
                                        <div className="bg-[#ffffff] rounded-[16px] px-[19px] pt-[13px] pb-6">

                                            <>
                                                <LogActivity
                                                    componentName="policy"
                                                    details={DealDetails}
                                                />

                                            </>

                                            <CommonLog
                                                date={moment.unix(DealDetails.created_at).format('YYYY/MM/DD').split('/').reverse()
                                                    .join('/')}
                                                time={moment.unix(DealDetails?.created_at).format('hh:mm a')}
                                                name={DealDetails.created_user_name}
                                                action="created"
                                                componentName="policy"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ) : 'Loading...!!'}
                    </div>
                )}
        </div>
    );
}

export default ViewDap;
